import { axios, captureException } from '@playbookux/playbook-web-core';
import { signOut } from '../actions';
import { store } from '../../store';
import { config } from '../../config';

class Client {
  constructor() {
    const client = axios.create({
      baseURL: config.REACT_APP_PLAYBOOKUX_API_URI,
    });

    client.interceptors.request.use(
      (configuration) => this.addAuthorizationHeader(configuration),
      (err) => {
        captureException('CLIENT_INTERCEPTOR_REQUEST_FAILED', err);
        return Promise.reject(err);
      },
    );

    client.interceptors.response.use(
      (response) => response,
      (err) => {
        const { response } = err;
        const statusCode = response?.status;
        const ignoredStatusCodes = [401, 503];

        if (ignoredStatusCodes.includes(statusCode)) {
          store.dispatch(signOut());
        }

        captureException('CLIENT_INTERCEPTOR_RESPONSE_FAILED', err);

        if (response && response.data) {
          const { data } = response;
          const { code, message } = data;

          const error = new Error(message);
          error.code = code;

          throw error;
        }

        throw err;
      },
    );

    this.client = client;
  }

  setToken(token) {
    this.token = token;
  }

  addAuthorizationHeader(configuration) {
    if (!this.token) {
      return configuration;
    }

    const request = configuration;
    request.headers.Authorization = `Bearer ${this.token}`;

    return request;
  }

  get(url, configuration) {
    return this.client.get(url, configuration);
  }

  delete(url, configuration) {
    return this.client.delete(url, configuration);
  }

  post(url, data, configuration) {
    return this.client.post(url, data, configuration);
  }

  put(url, data, configuration) {
    return this.client.put(url, data, configuration);
  }

  patch(url, data, configuration) {
    return this.client.patch(url, data, configuration);
  }
}

export default new Client();
